export const EXEC_INTERCOM = 'EXEC_INTERCOM';
export const LANGUAGE_CHANGE = 'LANGUAGE_CHANGE';
export const REQUEST_ADMIN_HOST = 'REQUEST_ADMIN_HOST';
export const REDIRECT_TO_INNER_PATH = 'REDIRECT_TO_INNER_PATH';
export const REQUEST_EVENT_TRACKERS_PATH = 'REQUEST_EVENT_TRACKERS_PATH';
export const REQUEST_FACEBOOK_ENTRANCE_PATH = 'REQUEST_FACEBOOK_ENTRANCE_PATH';
export const REQUEST_TIKTOK_PATH = 'REQUEST_TIKTOK_PATH';
export const ROUTE_CHANGE = 'ROUTE_CHANGE';
export const GOTO_APP_STORES = 'GOTO_APP_STORES';
